import React, { useState, useContext } from "react";
import { OperacaoContext } from "../../../context/OperacaoContext";
import { useNavigate, useLocation } from "react-router-dom";
import whatsappBgImg from "../../../assets/whatsapp-bg.png";
import "./EtapaEnvio.css";
import "bootstrap/dist/css/bootstrap.min.css";

// Função para renderizar texto com formatação personalizada
const renderComFormatacao = (texto) => {
  if (!texto) return null;

  const partes = texto.split(/(\*.*?\*|_.*?_|~.*?~)/g);

  return partes.map((parte, index) => {
    if (/^\*.*\*$/.test(parte)) {
      return <strong key={index}>{parte.slice(1, -1)}</strong>;
    } else if (/^_.*_$/.test(parte)) {
      return <em key={index}>{parte.slice(1, -1)}</em>;
    } else if (/^~.*~$/.test(parte)) {
      return <s key={index}>{parte.slice(1, -1)}</s>;
    } else {
      return parte;
    }
  });
};


const EtapaEnvio = ({ notifyColor, contasSelecionadas = [], gruposSelecionados = [], mensagens = [], mencionarTodos, novoNome = "", mensagem: propMensagem = "" }) => {
  const location = useLocation();
  // Busca dados do admin vindos da navegação
  const adminAdicionado = location?.state?.adminAdicionado;
  // Adiciona os dados do admin como mensagem no array, se existirem
  const mensagensComAdmin = adminAdicionado
    ? [...mensagens, { tipo: "texto", conteudo: `Administrador: ${adminAdicionado.nome} - ${adminAdicionado.numero}` }]
    : mensagens;
  const navigate = useNavigate();
  const { setOperacoes } = useContext(OperacaoContext);
  // Detecta se está em modo de edição e o índice
  let idxEdicao = null;
  if (location && location.state && typeof location.state.idx === 'number') {
    idxEdicao = location.state.idx;
  } else if (window.history && window.history.state && window.history.state.usr && typeof window.history.state.usr.idx === 'number') {
    idxEdicao = window.history.state.usr.idx;
  }


  // Função para enviar operação imediatamente
  const handleEnviarAgora = () => {
    // Prioriza a mensagem passada pela prop (por exemplo de Removeradm)
    let mensagensParaSalvar = (mensagens && mensagens.length > 0)
      ? mensagens
      : (propMensagem ? [{ tipo: 'texto', conteudo: propMensagem }] : (novoNome ? [{ tipo: 'texto', conteudo: novoNome }] : []));
    // Se for operação de mudar descrição, garantir que o tipo seja descricao
    if (mensagens && mensagens.length === 1 && mensagens[0].tipo === 'descricao') {
      mensagensParaSalvar = mensagens;
    }
    // Se for operação de mudar imagem, garantir que o tipo seja imagem
    if (mensagens && mensagens.length === 1 && mensagens[0].tipo === 'imagem') {
      mensagensParaSalvar = mensagens;
    }
    setOperacoes(prev => {
      const agora = new Date();
      const horaDisparo = agora.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
      // Detecta se é operação de mudar nome ou descrição
      const isMudarNome = !!novoNome;
      const isMudarDescricao = mensagensParaSalvar && mensagensParaSalvar.length === 1 && mensagensParaSalvar[0].tipo === 'descricao';
      const isMudarImagem = mensagensParaSalvar && mensagensParaSalvar.length === 1 && mensagensParaSalvar[0].tipo === 'imagem';
      if (idxEdicao !== null && prev[idxEdicao]) {
        // Atualiza operação existente
        const novas = [...prev];
        novas[idxEdicao] = {
          ...novas[idxEdicao],
          mensagens: mensagensParaSalvar,
          contas: contasSelecionadas,
          grupos: gruposSelecionados,
          mencionarTodos,
          status: 'Enviado',
          data: agora.toLocaleString(),
          horaDisparo,
          novoNome: novoNome,
          tipo: mensagensParaSalvar && mensagensParaSalvar.length === 1 && mensagensParaSalvar[0].tipo === 'config'
            ? 'Mudar Configuração'
            : (isMudarImagem ? 'Mudar Imagem' : (isMudarDescricao ? 'Mudar Descrição' : (isMudarNome ? 'Mudar Nome' : (prev[idxEdicao].tipo || 'Mensagem'))))
        };
        return novas;
      } else {
        // Adiciona nova operação
        return [
          ...prev,
          {
            mensagens: mensagensParaSalvar,
            contas: contasSelecionadas,
            grupos: gruposSelecionados,
            mencionarTodos,
            status: 'Enviado',
            data: agora.toLocaleString(),
            horaDisparo,
            novoNome: novoNome,
            tipo: mensagensParaSalvar && mensagensParaSalvar.length === 1 && mensagensParaSalvar[0].tipo === 'config'
              ? 'Mudar Configuração'
              : (isMudarImagem ? 'Mudar Imagem' : (isMudarDescricao ? 'Mudar Descrição' : (isMudarNome ? 'Mudar Nome' : 'Mensagem')))
          }
        ];
      }
    });
    navigate("/operacoes");
  };

  



  const handleAvancar = () => {
    navigate("/etapa-envio", { state: { contasSelecionadas } });
  };

  return (
    <div
      style={{
        "--notify-color": notifyColor, // Define a cor dinamicamente
      }}
    >
      <h3 style={{ color: notifyColor, marginBottom: 24, textAlign: "center" }}>
        Resumo da operação
      </h3>

      

      <div
        className="etapa-envio-boxes" // Adicione esta classe
        style={{
          display: "flex",
          flexDirection: "row", // Alinha os boxes em uma linha (desktop)
          justifyContent: "space-between", // Espaçamento entre os boxes
          gap: 16,
          width: "100%",
          maxWidth: 1200, // Define a largura máxima do container
          margin: "0 auto", // Centraliza o container
        }}
      >
        {/* Box 1: Operação */}
        <div
          style={{
            background: "#f0f4f8",
            borderRadius: 12,
            padding: 16,
            width: "30%", // Cada box ocupa 30% da largura
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            display: "flex",
            flexDirection: "column",
            gap: 12,
          }}
        >
          <div style={{ fontWeight: "bold", color: "#333" }}>Operação:</div>
          <div
            style={{
              color: "#005c53",
              fontWeight: "bold",
              fontSize: 16,
            }}
          >
            Enviar Mensagem
          </div>
          <div
            style={{
              marginTop: 12,
              padding: 16,
              backgroundImage: `url(${whatsappBgImg})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              borderRadius: 8,
              border: "1px solid #ccc",
              maxHeight: "300px",
              overflowY: "auto",
            }}
          >
            {mensagens.length > 0 ? (
              <>
                {mensagensComAdmin.map((msg, index) => (
                  <div
                    key={index}
                    style={{
                      padding: "12px 16px",
                      borderRadius: "16px",
                      background: "#DCF8C6",
                      color: "#333",
                      maxWidth: "80%",
                      marginBottom: 12,
                      wordWrap: "break-word",
                      whiteSpace: "pre-wrap",
                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
                      alignSelf: "flex-start",
                    }}
                  >
                    {msg.tipo === "audio" ? (
                      <AudioPlayer src={msg.conteudo} />
                    ) : msg.tipo === "imagem" ? (
                      <img
                        src={msg.conteudo}
                        alt="Imagem selecionada"
                        style={{
                          maxWidth: "100%",
                          borderRadius: "8px",
                          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
                        }}
                      />
                    ) : msg.tipo === "config" ? (
                        <span style={{ color: notifyColor, fontWeight: "bold" }}>
                          {(() => {
                            const opcoes = [
                              { value: 'admins_mensagens', label: 'Apenas admins enviam mensagens' },
                              { value: 'todos_mensagens', label: 'Todos podem enviar mensagens' },
                              { value: 'admins_config', label: 'Apenas admins mudam as configurações' },
                              { value: 'todos_config', label: 'Todos podem mudar as configurações' },
                            ];
                            const encontrada = opcoes.find(opt => opt.value === msg.conteudo || opt.label === msg.conteudo);
                            return encontrada ? encontrada.label : msg.conteudo;
                          })()}
                        </span>
                    ) : (
                      renderComFormatacao(msg.conteudo)
                    )}
                  </div>
                ))}
              </>
            ) : novoNome ? (
              <div
                style={{
                  padding: "12px 16px",
                  borderRadius: "16px",
                  background: "#DCF8C6",
                  color: "#333",
                  maxWidth: "80%",
                  marginBottom: 12,
                  wordWrap: "break-word",
                  whiteSpace: "pre-wrap",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
                  alignSelf: "flex-start",
                }}
              >
                {renderComFormatacao(novoNome)}
              </div>
            ) : (
              <div style={{ color: "#888", fontStyle: "italic" }}>
                Nenhuma mensagem selecionada.
              </div>
            )}
          </div>
        </div>

        {/* Box 2: Gatilho */}
        <div
          style={{
            background: "#f0f4f8",
            borderRadius: 12,
            padding: 16,
            width: "30%", // Cada box ocupa 30% da largura
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            display: "flex",
            flexDirection: "column",
            gap: 12,
          }}
        >
          <div style={{ fontWeight: "bold", color: "#333" }}>Gatilho:</div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 8,
            }}
          >
            {contasSelecionadas.length > 0 ? (
              contasSelecionadas.map((conta, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    padding: "8px 0",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  <img
                    src={conta.foto}
                    alt={conta.nome}
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                  <span style={{ fontSize: 16, color: "#333" }}>{conta.nome}</span>
                </div>
              ))
            ) : (
              <div style={{ color: "#888", fontStyle: "italic" }}>
                Nenhuma conta selecionada.
              </div>
            )}
          </div>
        </div>

        {/* Box 3: Grupos */}
        <div
          style={{
            background: "#f0f4f8",
            borderRadius: 12,
            padding: 16,
            width: "30%", // Cada box ocupa 30% da largura
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            display: "flex",
            flexDirection: "column",
            gap: 12,
          }}
        >
          <div style={{ fontWeight: "bold", color: "#333" }}>Campanha/Grupo:</div>
          <div
            style={{
              color: "#005c53",
              fontWeight: "bold",
              fontSize: 16,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 8,
            }}
          >
            {gruposSelecionados.length > 0 && gruposSelecionados[0]?.nomeCampanha ? (
              <>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  {gruposSelecionados[0].fotoCampanha && (
                    <img
                      src={gruposSelecionados[0].fotoCampanha}
                      alt="Capa Campanha"
                      style={{ width: 48, height: 48, borderRadius: '50%', objectFit: 'cover', border: '2px solid #51a197' }}
                    />
                  )}
                  <div>
                    <div>Campanha: {gruposSelecionados[0].nomeCampanha}</div>
                    <div>Grupo: {gruposSelecionados[0].nomeGrupo}</div>
                  </div>
                </div>
              </>
            ) : gruposSelecionados.length > 0 ? (
              gruposSelecionados.join(", ")
            ) : (
              "Nenhum grupo selecionado"
            )}
          </div>
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "center", marginTop: 32 }}>
        <button
          onClick={handleEnviarAgora}
          style={{
            padding: "16px 32px",
            borderRadius: 12,
            border: "none",
            background: notifyColor,
            color: "#fff",
            fontSize: 18,
            fontWeight: "bold",
            cursor: "pointer",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          }}
        >
          Enviar Agora
        </button>
      </div>
    </div>
  );
};

export default EtapaEnvio;